export class TopeCanal {
  id: number;
  idTopeCanal: string;
  idCanal: string;
  montoMinimo: number;
  montoMaximo: number;
  plazoMinimo: number;
  plazoMaximo: number;
  indicadorHabilitado: boolean;
  auditoriaFecha: Date;
  auditoriaUsuario: string;
  codigoCanal: string;
  canal: string;
  ip: string;
}
